import $ from "jquery";

const miGallery = () => {
  const init = () => {
    expandHandler();
    lightboxHandler();
  };

  const expandHandler = () => {
    const el = {
      gallery: ".mi-gallery",
      galleryFooter: ".mi-gallery-footer",
      expandBtn: ".mi-gallery-footer-btn",
    };

    if (!$(el.expandBtn).length) return;

    $(el.expandBtn).on("click", function () {
      const $gallery = $(el.gallery);
      const $btn = $(this);

      const isExpanded = $gallery.hasClass("expanded");

      if (isExpanded) {
        $gallery.removeClass("expanded");
        $btn
          .contents()
          .filter(function () {
            return this.nodeType === Node.TEXT_NODE;
          })
          .first()
          .replaceWith("Show more ");
      } else {
        $gallery.addClass("expanded");
        $btn
          .contents()
          .filter(function () {
            return this.nodeType === Node.TEXT_NODE;
          })
          .first()
          .replaceWith("Show less ");
      }
    });
  };

  const lightboxHandler = () => {
    $(".mi-gallery-grid-item-img").on("click", function () {
      const src = $(this).attr("src");
      $("#mi-gallery-lightbox-img").attr("src", src);
      $("#mi-gallery-lightbox").fadeIn().css("display", "flex");
    });

    $(".mi-gallery-lightbox-close, #mi-gallery-lightbox").on(
      "click",
      function (e) {
        if (e.target !== this) return; // close only if clicking overlay or X
        $("#mi-gallery-lightbox").fadeOut();
      }
    );
  };

  init();
};

try {
  miGallery();
} catch (e) {
  console.error("MI Gallery : ", e);
}
